import React from "react";
import { Box } from "@mui/material";
import logoMarkAlpha from "../../assets/logo-mark.png";

// Why this exists: the original mark (assets/logo.svg) is an OPAQUE black-and-
// white raster embedded in an SVG — it has no transparency, no vector path, and
// desire_company_fullname_logo_dark.svg is byte-identical to the light one, so
// there has never been a real dark variant. On the navy rail it renders as a
// dark blob with a white counter, and neither `fill`, a CSS filter, nor a mask
// can fix an opaque source.
//
// assets/logo-mark.png is the mark cropped out of assets/logo-transparent-tdc-only.png
// (the TDC lockup that DOES have a real alpha channel), with its ink normalised
// to white so it masks cleanly. Painting it as a
// CSS mask lets the mark take any theme token as its color, which is how the
// gold is applied here.
//
// Sized by HEIGHT with width from the artwork's own ratio, so it occupies the
// same box as the <img height=N width=auto> it replaces — no layout shift.
const ASPECT = 242 / 302;

interface BrandMarkProps {
  /** Rendered height in px; width follows the artwork's aspect ratio. */
  height?: number;
  /** Any CSS color — pass a theme token so the mark follows the theme. */
  color?: string;
  className?: string;
}

export function BrandMark({
  height = 26,
  color = "var(--accent-text)",
  className,
}: BrandMarkProps) {
  const mask = {
    maskImage: `url(${logoMarkAlpha})`,
    maskSize: "contain",
    maskRepeat: "no-repeat",
    maskPosition: "center",
  };
  return (
    <Box
      role="img"
      aria-label="The Desire Company"
      className={className}
      sx={{
        height,
        width: height * ASPECT,
        flex: `0 0 ${height * ASPECT}px`,
        backgroundColor: color,
        ...mask,
        WebkitMaskImage: mask.maskImage,
        WebkitMaskSize: mask.maskSize,
        WebkitMaskRepeat: mask.maskRepeat,
        WebkitMaskPosition: mask.maskPosition,
      }}
    />
  );
}
